var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 81,
    viewBox: "0 0 75 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.8741 26.1343C62.1614 29.9078 51.4312 29.7923 44.8981 25.8904C41.6893 23.978 40.0977 21.4879 40.0977 19.0236L40.0464 65.166C40.0464 67.6431 41.6379 70.1203 44.8467 72.0328C51.367 75.9346 62.11 76.0373 68.8228 72.2766C72.2369 70.3642 73.9569 67.81 73.9569 65.2558L74.0082 19.1134C74.0082 21.6676 72.2883 24.209 68.8741 26.1343Z",
    fill: "url(#paint0_linear_164633_182615)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2077 12.2467C62.6875 8.3448 51.9445 8.24212 45.2317 12.0028C38.5189 15.7764 38.3649 21.9886 44.8851 25.8905C51.4054 29.7923 62.1484 29.895 68.8612 26.1343C75.574 22.3608 75.728 16.1486 69.2077 12.2467ZM64.6641 23.6186C60.3387 26.0445 53.4205 25.9803 49.2106 23.4646C45.0006 20.9489 45.1033 16.9444 49.4288 14.5057C53.7542 12.0798 60.6724 12.144 64.8823 14.6597C69.0922 17.1754 68.9895 21.18 64.6641 23.6186Z",
    fill: "#F4F4F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6769 21.7319C60.3515 24.1577 53.4333 24.0936 49.2234 21.5779C47.1569 20.3457 46.1301 18.7413 46.1301 17.1497V19.0365C46.1301 20.6281 47.1441 22.2325 49.2234 23.4646C53.4333 25.9803 60.3515 26.0445 64.6769 23.6187C66.8717 22.3865 67.9884 20.7436 67.9884 19.1007V17.2139C67.9884 18.8568 66.8846 20.4997 64.6769 21.7319Z",
    fill: "url(#paint1_linear_164633_182615)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8946 12.7857C60.6847 10.27 53.7666 10.2059 49.4411 12.6317C45.1157 15.0575 45.013 19.0749 49.2229 21.5778C53.4329 24.0935 60.351 24.1577 64.6764 21.7318C69.0019 19.306 69.1046 15.2886 64.8946 12.7857ZM60.2612 19.1006C58.4386 20.1274 55.525 20.0889 53.7666 19.0364C51.9953 17.984 52.0338 16.2897 53.8564 15.2757C55.679 14.2489 58.5926 14.2874 60.351 15.3399C62.1223 16.3924 62.0837 18.0866 60.2612 19.1006Z",
    fill: "url(#paint2_linear_164633_182615)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3735 15.3143C56.5649 14.8266 55.5124 14.557 54.4342 14.5057C54.3444 14.5057 54.2417 14.5057 54.1518 14.5057C52.971 14.5057 51.7902 14.7367 50.8789 15.2501C49.0563 16.277 49.0178 17.9584 50.789 19.0108C51.6747 19.5371 52.8298 19.8066 54.0107 19.8195C54.062 19.8195 57.5147 19.8195 57.5788 19.8195L57.3863 15.3015L57.3735 15.3143Z",
    fill: "#9B9BA0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2741 17.2139C58.4515 18.2407 55.5379 18.2022 53.7795 17.1497C52.9067 16.6235 52.4832 15.9561 52.4832 15.2886V17.1754C52.4832 17.8428 52.9067 18.5231 53.7795 19.0365C55.5508 20.089 58.4643 20.1275 60.2741 19.1007C61.1982 18.5873 61.6603 17.8942 61.6731 17.2011V15.3143C61.6731 16.0074 61.2111 16.7005 60.2869 17.2139H60.2741Z",
    fill: "url(#paint3_linear_164633_182615)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3642 13.4532C58.5929 12.4007 55.6794 12.3622 53.8696 13.389C52.047 14.4158 52.0085 16.0972 53.7798 17.1497C55.551 18.2022 58.4646 18.2407 60.2743 17.2139C62.0969 16.1871 62.1354 14.5057 60.3642 13.4532Z",
    fill: "url(#paint4_linear_164633_182615)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6063 33.168V70.4797C62.8548 70.2616 67.6166 69.0679 70.9024 66.3853V29.0735C69.1953 30.4726 67.1032 31.4609 64.8827 32.1155C62.8163 32.7316 60.6471 33.0653 58.5935 33.168H58.6063Z",
    fill: "#5B5B5B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5145 35.3243C64.1505 37.917 60.5053 37.6475 58.6057 37.9683V40.4969C63.6243 40.1631 68.9637 38.0068 70.9018 36.1714V34.0279C70.2087 33.9509 69.3872 34.8109 68.5145 35.3243Z",
    fill: "#656568"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9018 43.4104V41.2541C70.2087 41.1771 69.3872 42.0371 68.5145 42.5505C67.5261 43.1409 66.1014 43.7827 64.5997 44.2191C61.776 45.0662 59.7994 45.0662 58.6057 45.2074V47.7231C63.4061 47.4022 68.9123 45.2715 70.9018 43.4104Z",
    fill: "#656568"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6063 36.8902C62.6879 36.6206 67.3471 35.2729 70.9024 32.5262V30.4213C70.6457 30.3699 70.3762 30.4213 70.0938 30.6266C66.7182 33.2065 62.9061 34.0793 58.5935 34.3745V36.8902H58.6063Z",
    fill: "#656568"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.106 59.4928C68.6556 60.6095 66.9999 61.5465 64.5997 62.2524C61.776 63.0995 59.8122 63.0995 58.6057 63.2664V65.7692C62.7258 65.4997 67.3721 64.1263 70.9018 61.4053V59.3132C70.6323 59.2618 70.3499 59.3132 70.0932 59.5057L70.106 59.4928Z",
    fill: "url(#paint5_radial_164633_182615)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9024 39.7396V37.6346C70.6457 37.5833 70.3762 37.6346 70.0938 37.84C65.1523 41.6263 60.7626 41.2028 58.5935 41.575V44.1035C62.6751 43.834 67.3471 42.4735 70.8896 39.7396H70.9024Z",
    fill: "#656568"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9024 64.9863V62.8813C70.6457 62.83 70.3633 62.8813 70.0938 63.0867C68.6434 64.1905 66.9877 65.1403 64.5875 65.8463C61.7638 66.6934 59.7872 66.6934 58.5935 66.8346V69.3503C62.7393 69.0679 67.3599 67.7202 70.8896 64.9863H70.9024Z",
    fill: "url(#paint6_radial_164633_182615)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M70.106 45.0662C66.8459 47.5562 62.5076 48.6857 58.6057 48.8269V51.3297C62.867 51.0473 67.4235 49.6611 70.9018 46.9658V44.8608C70.6451 44.8095 70.3627 44.8608 70.0932 45.0662H70.106Z",
    fill: "#656568"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9018 48.429C70.2857 48.3648 69.5926 49.1221 68.5145 49.751C65.4982 51.5479 61.9557 52.1768 58.6057 52.4079V54.9235C63.5729 54.5898 68.9508 52.4464 70.9018 50.6109V48.429Z",
    fill: "#656568"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6856 58.2864C64.4463 57.7216 67.9375 56.4766 70.9024 54.1663V52.0742C70.6329 52.0228 70.3505 52.0742 70.0938 52.2667C68.6691 53.3577 67.0519 54.3075 64.5875 55.0263C61.7381 55.8862 59.7872 55.8862 58.5935 56.0274V58.5302C59.2224 58.5302 59.9797 58.4019 60.6728 58.2864H60.6856Z",
    fill: "#656568"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M70.106 55.8862C66.7432 58.4661 62.8798 59.3389 58.6057 59.6341V62.1498C58.7982 62.1369 59.594 62.0727 60.685 61.9059C64.343 61.354 67.8855 60.1346 70.9018 57.7858V55.6808C70.6451 55.6295 70.3627 55.6808 70.0932 55.8862H70.106Z",
    fill: "#656568"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1188 29.6383V65.9233C67.0384 68.4518 62.6488 69.6455 58.6057 69.9535V70.4669C62.8541 70.2487 67.616 69.055 70.9018 66.3725V29.0735C70.6579 29.2789 70.3755 29.4586 70.1188 29.6383Z",
    fill: "#5B5B5B"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.9,
    d: "M60.9793 14.5312C61.6211 14.9035 61.2489 16.1228 59.8627 16.9186C58.4765 17.7272 56.5769 17.8042 55.9479 17.432C55.3062 17.0598 55.9223 16.11 57.3085 15.3142C58.6947 14.5056 60.3504 14.159 60.9793 14.5312Z",
    fill: "url(#paint7_linear_164633_182615)"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4892 20.7948C27.2234 25.4283 14.0031 25.3 5.96835 20.4996C2.02795 18.1251 0.0641758 15.0832 0.0641758 12.0284L0 68.8496C0 71.8916 1.95094 74.9463 5.90417 77.308C13.939 82.1083 27.1592 82.2495 35.425 77.6032C39.6221 75.2415 41.7399 72.1098 41.7527 68.9651L41.8169 12.1568C41.8169 15.3014 39.6991 18.4332 35.4892 20.7948Z",
    fill: "url(#paint8_linear_164633_182615)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9125 3.69841C27.8777 -1.11477 14.6575 -1.24312 6.39164 3.39037C-1.87419 8.02386 -2.06672 15.6864 5.96808 20.4868C14.0029 25.2871 27.2231 25.4283 35.4889 20.782C43.7548 16.1485 43.9473 8.48592 35.9125 3.68558V3.69841ZM30.3292 17.7016C25.0026 20.6922 16.4801 20.6023 11.2947 17.509C6.10927 14.4158 6.23762 9.47423 11.5642 6.48364C16.8908 3.49305 25.4133 3.5829 30.5987 6.67617C35.7841 9.76944 35.6558 14.711 30.3292 17.7016Z",
    fill: "#F4F4F4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3295 15.3784C25.0029 18.369 16.4804 18.2791 11.295 15.1859C8.75359 13.6585 7.48291 11.6947 7.48291 9.73093V12.0541C7.48291 14.0179 8.74075 15.9816 11.2821 17.509C16.4675 20.6023 24.9772 20.6921 30.3166 17.7016C33.0249 16.187 34.3854 14.1591 34.3982 12.1311V9.80794C34.3982 11.8359 33.0377 13.8638 30.3295 15.3784Z",
    fill: "url(#paint9_linear_164633_182615)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5988 4.353C25.4134 1.25973 16.9037 1.16988 11.5643 4.16047C6.23767 7.15106 6.10932 12.0798 11.2947 15.1859C16.4801 18.2791 24.9898 18.369 30.3293 15.3784C35.6558 12.3878 35.7842 7.45911 30.5988 4.353ZM24.8871 12.1311C22.641 13.3889 19.06 13.3504 16.878 12.0541C14.696 10.7577 14.7474 8.67845 16.9935 7.4206C19.2397 6.16276 22.8207 6.20126 25.0027 7.49761C27.1846 8.79396 27.1333 10.8733 24.8871 12.1311Z",
    fill: "url(#paint10_linear_164633_182615)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3328 7.48475C20.3316 6.8815 19.0353 6.56062 17.7004 6.49645C17.5849 6.49645 17.4694 6.49645 17.3539 6.49645C15.9035 6.48361 14.4531 6.79166 13.3236 7.42058C11.0775 8.67842 11.0261 10.7577 13.2081 12.0541C14.2991 12.7087 15.7238 13.0424 17.1742 13.0552C17.2384 13.0552 21.4996 13.0552 21.5638 13.0552L21.3328 7.49759V7.48475Z",
    fill: "#9B9BA0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9004 9.80791C22.6542 11.0658 19.0732 11.0273 16.8913 9.7309C15.8259 9.08915 15.2869 8.2677 15.2869 7.43341V9.75657C15.2869 10.578 15.8131 11.4123 16.8784 12.0541C19.0604 13.3504 22.6414 13.3889 24.8876 12.1311C26.0299 11.4893 26.5946 10.6422 26.6075 9.78224V7.45908C26.6075 8.3062 26.0427 9.16616 24.9004 9.80791Z",
    fill: "url(#paint11_linear_164633_182615)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0154 5.17443C22.8334 3.87808 19.2524 3.83957 17.0062 5.09742C14.7601 6.35526 14.7088 8.43456 16.8907 9.73091C19.0727 11.0273 22.6537 11.0658 24.8999 9.80792C27.146 8.55008 27.1974 6.47078 25.0154 5.17443Z",
    fill: "url(#paint12_linear_164633_182615)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8462 29.4586V75.3956C28.0701 75.126 33.9486 73.6628 37.9917 70.3514V24.4015C35.8995 26.1214 33.3068 27.3408 30.5858 28.1494C28.0444 28.9067 25.3747 29.3174 22.8462 29.4457V29.4586Z",
    fill: "#5B5B5B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0524 32.1155C29.6873 35.3114 25.195 34.9777 22.8462 35.3756V38.4945C29.0327 38.0838 35.5915 35.4269 37.9917 33.1679V30.5239C37.1317 30.434 36.1177 31.4865 35.0524 32.1155Z",
    fill: "#656568"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9917 42.0627V39.4059C37.1317 39.316 36.1177 40.3685 35.0524 40.9974C33.8331 41.7162 32.0747 42.512 30.2264 43.051C26.7481 44.1035 24.3222 44.0907 22.8462 44.2704V47.3636C28.7504 46.9658 35.5273 44.3345 37.9917 42.0627Z",
    fill: "url(#paint13_radial_164633_182615)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8462 34.0407C27.8776 33.707 33.6149 32.0385 37.9917 28.6628V26.0701C37.6836 26.0059 37.3371 26.0701 37.0034 26.3268C32.8448 29.5099 28.1471 30.5753 22.8462 30.9475V34.0407Z",
    fill: "#656568"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0034 61.8545C35.2193 63.2279 33.1785 64.383 30.2264 65.2558C26.7609 66.2955 24.3222 66.3083 22.8462 66.5008V69.5813C27.9161 69.2476 33.6406 67.5662 37.9917 64.2034V61.6363C37.658 61.5721 37.3114 61.6363 37.0034 61.8802V61.8545Z",
    fill: "url(#paint14_radial_164633_182615)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9917 37.5447V34.952C37.6836 34.8879 37.3371 34.952 37.0034 35.2087C30.9195 39.8679 25.5159 39.3545 22.8462 39.8037V42.9227C27.8647 42.589 33.6149 40.9204 37.9917 37.5447Z",
    fill: "url(#paint15_radial_164633_182615)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9917 68.6315V66.0388C37.6836 65.9746 37.3371 66.0388 37.0034 66.2955C35.2193 67.6688 33.1785 68.824 30.2264 69.6968C26.7481 70.7493 24.3222 70.7364 22.8462 70.9161V74.0094C27.9546 73.6629 33.6277 71.9943 37.9917 68.6315Z",
    fill: "url(#paint16_radial_164633_182615)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0034 44.0907C32.986 47.1583 27.6465 48.5445 22.8462 48.7113V51.7917C28.0958 51.4452 33.6919 49.7381 37.9917 46.4138V43.8211C37.6836 43.7569 37.3371 43.8211 37.0034 44.0778V44.0907Z",
    fill: "url(#paint17_radial_164633_182615)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9917 48.2493C37.2344 48.1594 36.3744 49.0964 35.0524 49.8793C31.3302 52.087 26.9791 52.8699 22.8462 53.1523V56.2456C28.9557 55.8348 35.5787 53.1908 37.9917 50.9318V48.2493Z",
    fill: "url(#paint18_radial_164633_182615)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4132 60.3913C30.0339 59.6854 34.3337 58.158 37.9917 55.3214V52.7416C37.658 52.6774 37.3114 52.7416 37.0034 52.9854C35.2449 54.3331 33.2683 55.4883 30.2264 56.3868C26.7224 57.4392 24.3094 57.4392 22.8462 57.6061V60.6865C23.6291 60.6994 24.5533 60.5197 25.4132 60.3913Z",
    fill: "url(#paint19_radial_164633_182615)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0034 57.4136C32.8576 60.5839 28.1086 61.662 22.8462 62.0342V65.1275C23.0901 65.1147 24.0527 65.0377 25.4132 64.8195C29.9184 64.1392 34.2695 62.6375 37.9917 59.7496V57.1569C37.6836 57.0927 37.3371 57.1569 37.0034 57.4136Z",
    fill: "url(#paint20_radial_164633_182615)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0294 25.1075V69.7866C33.2302 72.8927 27.8266 74.3688 22.8594 74.7538V75.3956C28.0833 75.126 33.9618 73.6628 38.0049 70.3514V24.4015C37.6968 24.6582 37.3631 24.8764 37.0294 25.1075Z",
    fill: "#5B5B5B"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.2,
    d: "M22.8462 29.4586V75.3956C28.0701 75.126 33.9486 73.6628 37.9917 70.3514V24.4015C35.8995 26.1214 33.3068 27.3408 30.5858 28.1494C28.0444 28.9067 25.3747 29.3174 22.8462 29.4457V29.4586Z",
    fill: "url(#paint21_linear_164633_182615)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.9,
    d: "M25.8245 6.47079C26.6203 6.93285 26.171 8.4474 24.4383 9.44854C22.7055 10.4497 20.3567 10.5524 19.5609 10.0903C18.7651 9.62823 19.5224 8.4474 21.2552 7.44626C22.9879 6.44512 25.0415 6.00872 25.8373 6.47079H25.8245Z",
    fill: "url(#paint22_linear_164633_182615)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_164633_182615",
    x1: 40.0464,
    y1: 47.0171,
    x2: 74.0082,
    y2: 47.0171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_164633_182615",
    x1: 46.1301,
    y1: 21.2698,
    x2: 67.9884,
    y2: 21.2698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C7C80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#929296"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_164633_182615",
    x1: 46.1297,
    y1: 17.1753,
    x2: 67.9879,
    y2: 17.1753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_164633_182615",
    x1: 52.4703,
    y1: 17.5605,
    x2: 61.6603,
    y2: 17.5605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C7C80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#929296"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_164633_182615",
    x1: 52.4706,
    y1: 15.3015,
    x2: 61.6605,
    y2: 15.3015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDFE5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_164633_182615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.8436 62.7273) scale(10.3066 10.3066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0091C1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_164633_182615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.6902 66.026) scale(12.3217 12.3217)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#0085B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_164633_182615",
    x1: 55.6912,
    y1: 16.0201,
    x2: 61.2874,
    y2: 16.0201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDFE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_164633_182615",
    x1: 0,
    y1: 46.5165,
    x2: 41.8169,
    y2: 46.5165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_164633_182615",
    x1: 7.48291,
    y1: 14.8136,
    x2: 34.4111,
    y2: 14.8136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C7C80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#929296"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_164633_182615",
    x1: 7.49552,
    y1: 9.76943,
    x2: 34.4108,
    y2: 9.76943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_164633_182615",
    x1: 15.2869,
    y1: 10.2443,
    x2: 26.6203,
    y2: 10.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C7C80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#929296"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_164633_182615",
    x1: 15.2992,
    y1: 7.44625,
    x2: 26.6198,
    y2: 7.44625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDFE5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_164633_182615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.4189 43.3847) scale(6.04536)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#0085B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081B1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_164633_182615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.5344 65.8591) scale(12.6811 12.6811)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#0085B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081B1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_164633_182615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.4189 38.9309) scale(6.05819 6.05819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#0085B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081B1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_164633_182615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.3419 69.9022) scale(15.1712 15.1711)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#0085B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081B1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_164633_182615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.4189 47.8129) scale(6.05819 6.05819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#0085B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081B1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_164633_182615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.4189 52.2538) scale(6.05819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#0085B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081B1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_164633_182615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.4189 56.6948) scale(6.04536 6.04536)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#0085B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081B1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_164633_182615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.4189 61.1358) scale(6.05819 6.05819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#0085B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0081B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_164633_182615",
    x1: 35.6813,
    y1: 27.5846,
    x2: 24.6303,
    y2: 74.4971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ED7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_164633_182615",
    x1: 19.24,
    y1: 8.31905,
    x2: 26.2095,
    y2: 8.31905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDFE5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.e7bd9420b91f0406c34684c27f291b22.svg";
export { ForwardRef as ReactComponent };